<div class="modal-dialog modal-dialog-scrollable m-0 scrollable-dialog">
    <form class="kt-form w-webkit-fill-available">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Livechat Settings</h5>
                <span class="modal-x-button" (click)="onCloseDialog()">
                    <i class="fa fa-times" aria-hidden="true"></i>
                </span>
            </div>
            <div class="modal-body">
                <div class="row px-3">
                    <div class="col-3 d-flex align-items-center justify-content-start">
                        <label class="m-0">{{ 'AI Chatbot Toggle' }}</label>
                        <i class="fas fa-info-circle ml-2" matTooltip="Overrides the current livechat system with Ganba's livechat system. All livechat script related settings in BO will be ignored."></i>
                    </div>
                    <div class="col-9">
                        <label class="switch m-0">
                            <input type="checkbox" id="togBtn" [checked]="aIChatbotStatus" [(ngModel)]="aIChatbotStatus" [ngModelOptions]="{standalone: true}">
                            <div class="slider round">
                                <span class="on">ON</span>
                                <span class="off">OFF</span>
                            </div>
                        </label>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="onCloseDialog()"><i class="fas fa-ban"></i>Close</button>
                <kt-submit-button [buttonLoading]="buttonLoading" (confirmed)="onUpdateStatus()"></kt-submit-button>
            </div>
        </div>
    </form>
</div>
<kt-swal-alert [message]="messages$ | async" (confirmed)="onCloseDialog()"></kt-swal-alert>